export enum AuthMethodId {
  Default = 'default',
  Google = 'google',
  Okta = 'okta'
}

export interface AuthMethod {
  id: AuthMethodId;
  name: string;
  /** Image path (e.g. `/assets/auth/{name}.png`) */
  image: string;
}

export interface AuthConfig {
  /** @default [authMethod.default] */
  methods?: AuthMethod[];
  /** @default AuthMethodId.Default */
  defaultId?: AuthMethodId;
}
